import { SparklesIcon } from 'lucide-react'
import { useEffect, useState } from 'react'

import { cn, shuffleArray } from '@/utils'

interface LiveFeedbackPanelProps {
  phrases: string[]
  phraseIntervalMs?: number
  fadeDurationMs?: number
}

export const LiveFeedbackPanel = ({
  phrases,
  phraseIntervalMs = 3500,
  fadeDurationMs = 400,
}: LiveFeedbackPanelProps) => {
  const shuffledPhrases = shuffleArray(phrases)
  const [phraseIndex, setPhraseIndex] = useState(0)
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false)

      setTimeout(() => {
        setPhraseIndex((prev) => (prev + 1) % shuffledPhrases.length)
        setIsVisible(true)
      }, fadeDurationMs)
    }, phraseIntervalMs)

    return () => clearInterval(interval)
  }, [shuffledPhrases.length])

  return (
    <div className="max-w-md mx-auto py-20 flex flex-col items-center gap-6">
      <div className="relative mx-auto h-14 w-14">
        <div className="absolute inset-0 rounded-full bg-brand/10 animate-ping [animation-duration:2s]" />
        <div className="relative flex h-14 w-14 items-center justify-center rounded-full bg-brand/10">
          <SparklesIcon className="h-6 w-6 text-brand animate-pulse" />
        </div>
      </div>

      <div className="text-center space-y-2">
        <h2 className="text-xl font-semibold">Daystrom is on the case</h2>
        <p className="text-sm text-muted-foreground text-pretty">
          This typically takes 5-10 minutes. You can leave this page and come
          back — the report will be waiting for you.
        </p>
      </div>

      <div className="h-6 flex items-center">
        <p
          className={cn(
            'text-sm text-muted-foreground italic transition-opacity duration-400',
            isVisible ? 'opacity-100' : 'opacity-0',
          )}
        >
          {shuffledPhrases[phraseIndex]}
        </p>
      </div>
    </div>
  )
}
